import React from 'react';
import ContentContainer from '../../BuildingBlocks/Container/ContentContainer';
import NextButton from '../../SubmitApplication/NextButton';
import { useEventTrackerContext } from 'frontend/src/contexts/EventTracker';
import AccountsComplete from '../../SubmitApplication/AccountsComplete';

export default function ConnectAccountCompleted({ goForward }) {
  const { trackEvent } = useEventTrackerContext();

  async function handleSubmit() {
    trackEvent({
      event: 'click_next_connect_accounts_completed',
    });
    goForward();
  }

  return (
    <ContentContainer width={600}>
      <AccountsComplete isHangTight={true} />
      <NextButton onClick={handleSubmit} isPrimary={true} />
    </ContentContainer>
  );
}
